import React, { useState, useEffect, useCallback } from 'react';
import { ProfileCard, PasswordCard, C } from './ProfileCards';

const BASE = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';

// Кабінет у бектестингу — лише особисті дані акаунта: імʼя, пошта, телефон,
// аватарка, пароль. Торгівлі тут немає (брокер, бот, баланс, віртуальна
// торгівля живуть у торговому кабінеті), тож і на цій сторінці її немає.
export default function CalcAccountPage() {
  const [user,  setUser]  = useState(null);
  const [error, setError] = useState('');

  const loadProfile = useCallback(async () => {
    try {
      const r = await fetch(`${BASE}/api/user/profile`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      if (!r.ok) throw new Error();
      const d = await r.json();
      setUser(d?.user || {});
      setError('');
    } catch {
      setError('Не вдалося завантажити профіль');
    }
  }, []);

  useEffect(() => { loadProfile(); }, [loadProfile]);

  const created = user?.created_at
    ? new Date(user.created_at).toLocaleDateString('uk-UA', { day: 'numeric', month: 'long', year: 'numeric' })
    : null;

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '24px 16px' }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, margin: 0, color: C.textMain }}>Мій акаунт</h1>
        {user && (
          <div style={{ color: C.textDim, fontSize: 13, marginTop: 4 }}>
            {user.username}
            {created && <> · зареєстровано {created}</>}
          </div>
        )}
      </div>

      {error && (
        <div style={{
          padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 13,
          background: '#FEF2F2', color: '#DC2626',
        }}>
          {error}
        </div>
      )}

      {user && (
        // Як на app.*/settings: на десктопі в один рядок, на телефоні одне під одним
        <div style={{
          display: 'grid', gap: 20, alignItems: 'stretch',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 460px), 1fr))',
        }}>
          <ProfileCard user={user} onSaved={loadProfile} />
          <PasswordCard user={user} onSaved={loadProfile} />
        </div>
      )}
    </div>
  );
}
